module.exports = __webpack_public_path__ + "img/drawFadeText1.64aedc27.png";